import { Component } from '@angular/core';

@Component({
  selector: 'app-a-propos',
  templateUrl: './apropos-nous.component.html',
  styleUrls: ['./apropos-nous.component.scss']
})
export class AProposComponent {


  currentYear = new Date().getFullYear();

  
  valeurs = [
    { icon: '🧪', titre: 'Innovation utile', texte: 'Des solutions modernes, simplement utilisables et mesurables.' },
    { icon: '⚙️', titre: 'Excellence technique', texte: 'Performance, sécurité, accessibilité et SEO by design.' },
    { icon: '🎯', titre: 'ROI & clarté', texte: 'Objectifs chiffrés, priorisation par impact/effort, reporting net.' }
  ];

  etapes = [
    { titre: 'Découverte', texte: 'Atelier objectifs, audiences, parcours et KPIs.' },
    { titre: 'Conception', texte: 'UX/UI, architecture, contenus, SEO et performance.' },
    { titre: 'Développement', texte: 'Intégration propre, QA multi-devices, conformité RGPD.' },
    { titre: 'Lancement & suivi', texte: 'Monitoring, optimisation continue et accompagnement.' }
  ];

  scrollTo(id: string) {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
